export const gtmEventTypes = {
  CLICK_SUB_NAV_LINK: 'FED-IPN-001',
  CLICK_SUB_NAV_BUTTON: 'FED-IPN-002',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_SUB_NAV_LINK]: ({CMSGroupGTM, itemName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_SUB_NAV_LINK,
    event: 'reactjs.event',
    pageAction: `Clicked Sub Nav Link - "${itemName.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_SUB_NAV_BUTTON]: ({CMSGroupGTM, ctaName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_SUB_NAV_BUTTON,
    event: 'reactjs.event',
    pageAction: `Clicked Sub Nav Button - "${ctaName.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/in-page-navigation-duck.js